<script>
    import { onMount, onDestroy } from "svelte";
    export let isOpen = false;
    export let width = "w-1/2";

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            closePopup();
        }
    };

    const handleClickOutside = (event) => {
        if (event.target.id === 'popup-overlay') {
            closePopup();
        }
    };

    onMount(() => {
        window.addEventListener('keydown', handleKeyDown);
        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    });

    onDestroy(() => {
        window.removeEventListener('keydown', handleKeyDown);
    });

    function closePopup() {
        isOpen = false;
    }
</script>

{#if isOpen}
    <div id="popup-overlay" class="fixed inset-0 flex items-center justify-center bg-gray-800 bg-opacity-75" on:click={handleClickOutside} aria-label="Close Popup" role="presentation">
        <div class="bg-white p-6 rounded-lg shadow-lg relative {width} max-h-[calc(100vh-150px)] overflow-auto">
            <button class="absolute top-2 right-2 text-gray-500 hover:text-gray-700" on:click={closePopup}>
                &times;
            </button>
            <slot />
        </div>
    </div>
{/if}
